import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { t } from 'i18next';
import { useCallback, useEffect, useRef, useState } from 'react'
// import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import DataGridWrapper from '@/projects/syncflow/components/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import React from 'react';
import SelectBox, { SelectBoxTypes } from 'devextreme-react/select-box';
import { Button } from 'devextreme-react/button';
import { DataGrid, Popup } from 'devextreme-react';
import { additionalService } from '../services/additional-service';
import { DataGridTypes } from 'devextreme-react/cjs/data-grid';
import { toast } from 'react-toastify';
import { alert, confirm } from 'devextreme/ui/dialog';
import { Validator, RequiredRule } from 'devextreme-react/validator';
import { productSupplyParamService } from '../services/product_supply_parameter-service';
import { invoiceService } from '../services/invoice-service';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';

const AdditionalOrder = () => {
    const validatorRef = useRef(null);
    const dataGridRef = useRef<DataGrid>(null);
    const dgVendorSummaryRef = useRef<DataGrid>(null);

    const [store, setStore] = useState<CustomStore>();

    const [additionalOrderData] = useState<any>(
        {
            sourceCode: null, targetCode: null, lines: null
        }
    );

    const [additionalOrderUpdateData] = useState<any>(
        {
            orderId: null, status: null
        }
    );

    useEffect(() => {
        setStore(new CustomStore({
            key: ["id"],
            load: onGetProductData,
            update: additionalService.updatePreorder,
            useDefaultSearch: true
        }));
    }, [])

    const params = useParams();

    const onGetProductData = useCallback(async () => {
        getInvoice();
        const x = await additionalService.getAdditionalDetailList(params.id);
        return x;
    }, []);


    const [additionalDetailData, setvendorSupplyData] = useState<any>();
    const [isNew, setIsNew] = useState(false);
    const getInvoice = async () => {
        setIsNew(!params.id ? true : false);

        const data = await additionalService.getAdditional(params ? params.id : -1);
        setvendorSupplyData(data)

        locationValue = data.sourceCode;
        supplierValue = data.targetCode;
    };


    const [storeVendorSummaries, setStoreVendorSummaries] = useState<CustomStore>();
    useEffect(() => {
        setStoreVendorSummaries(new CustomStore({
            key: ["productCode"],
            load: onGetVendorSummaries,
            useDefaultSearch: true
        }));
    }, [])




    const onGetVendorSummaries = useCallback(async () => {
        return await productSupplyParamService.getProductsForSupplier(supplierValue, locationValue, dataGridRef.current?.instance.getVisibleRows());
    }, []);


    let [locationValue, setLocationValue] = useState("");
    const onLocationChanged = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        setLocationValue(e.value);
        locationValue = e.value;
        getSupplierLookups();
    }, [setLocationValue]);

    let [supplierValue, setSupplierValue] = useState("");
    const onSupplierChanged = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        setSupplierValue(e.value);
        supplierValue = e.value;

        let lenght = dataGridRef.current?.instance.getVisibleRows().length;
        if (lenght && lenght > 0) {
            let result = confirm(t("syncflow:confirm_delete"), t("syncflow:ti_confirm"));
            result.then((dialogResult) => {
                if (dialogResult) {
                    dataGridRef.current?.instance.cancelEditData();
                }
            });
        }

    }, [setSupplierValue]);

    const [locationsLookups] = useState(new CustomStore({
        load: invoiceService.getLocationLookups,
        useDefaultSearch: true
    }));

    const [supplierLookups, setSuppliers] = useState();
    const getSupplierLookups = async () => {
        setSuppliers(await productSupplyParamService.getSupplierForLocation(locationValue))
    };


    const onSave = async () => {
        if (dataGridRef.current?.instance.hasEditData()) {

            let result = confirm(t("syncflow:msg_save_confirm"), t("syncflow:ti_confirm"));
            result.then((dialogResult) => {
                if (dialogResult) {
                    dataGridRef.current?.instance.saveEditData().then(x => {
                        dataGridRef.current?.instance.refresh().then(x => dataGridRef.current?.instance.cancelEditData());
                    });
                }
            });
        }
    }

    const onCreateOrder = async () => {

        let result = await confirm(t("syncflow:msg_approve_confirm_supplier"), t("syncflow:ti_confirm"));
        if (!result) return;

        if (dataGridRef.current?.instance.hasEditData()) {
            let result = confirm(t("syncflow:msg_save_confirm"), t("syncflow:ti_confirm"));
            result.then((dialogResult) => {
                if (dialogResult) {
                    dataGridRef.current?.instance.saveEditData().then(x => {
                        //save
                        dataGridRef.current?.instance.refresh().then(x => {
                            dataGridRef.current?.instance.cancelEditData();

                            additionalOrderUpdateData.orderId = additionalDetailData.id;
                            additionalOrderUpdateData.status = 100;
                            additionalService.updateAdditionalMaster(additionalOrderUpdateData)
                                .then((response) => {
                                    toast.success(t("syncflow:msg_saved"));
                                    navigate(`/syncflow/order-list`);
                                })
                        }
                        );
                    });
                }
                else {
                    dataGridRef.current?.instance.cancelEditData();
                    dataGridRef.current?.instance.refresh();

                    additionalOrderUpdateData.orderId = additionalDetailData.id;
                    additionalOrderUpdateData.status = 100;
                    additionalService.updateAdditionalMaster(additionalOrderUpdateData)
                        .then((response) => {
                            toast.success(t("syncflow:msg_saved"));
                            navigate(`/syncflow/order-list`);
                        })
                }
            });
        }
        else {
            dataGridRef.current?.instance.refresh();

            additionalOrderUpdateData.orderId = additionalDetailData.id;
            additionalOrderUpdateData.status = 100;
            additionalService.updateAdditionalMaster(additionalOrderUpdateData)
                .then((response) => {
                    toast.success(t("syncflow:msg_saved"));
                    navigate(`/syncflow/order-list`);
                })
        }



    }

    const onAdd = async () => {
        dgVendorSummaryRef.current?.instance.refresh().then(x => showInfoOrders(0));
    }

    const onSaving = (e: DataGridTypes.SavingEvent) => {
        e.cancel = true;
        if (e.changes.length > 0) {

            additionalOrderData.id = params ? params.id : null;
            additionalOrderData.id = parseInt(additionalOrderData.id);
            additionalOrderData.sourceCode = locationValue;
            additionalOrderData.targetCode = supplierValue;
            additionalOrderData.lines = e.changes;

            additionalService.saveAdditionalOrder(additionalOrderData).then((response) => {
                dataGridRef.current?.instance.refresh().then(x => dataGridRef.current?.instance.cancelEditData());
                
                if (response.success)
                    toast.success(t("syncflow:msg_saved"));

                if (isNew) {
                    navigate(`/syncflow/additional-order/` + response.id);
                    window.location.reload();
                }
            });
        }
    }

    const navigate = useNavigate();


    const onCellPrepared = async (e: any) => {
        if (e.hasOwnProperty("data")) {
            if (e.column.dataField === 'orderQty') {
                e.cellElement.style.backgroundColor = '#E6F1FF';
            }
        }
    };



    const [popupVisibleOrders, setPopupVisibleOrders] = useState(false);
    const showInfoOrders = useCallback((e: any) => {
        setPopupVisibleOrders(true);
    }, [setPopupVisibleOrders]);

    const hideInfoOrders = useCallback(() => {
        setPopupVisibleOrders(false);
    }, [setPopupVisibleOrders]);


    const newProductRow: any = {};
    const approveOrders = () => {

        selectedRowKeys.forEach((result: any) => {

            newProductRow.productCode = result.productCode;
            newProductRow.productName = result.productName;
            newProductRow.unitCode = result.unit;
            newProductRow.price = result.price;
            newProductRow.waitingBalance = result.waitingBalance;
            dataGridRef.current?.instance.addRow();

            // if (dataGridRef.current?.instance.getVisibleRows().filter(x => x.data.productCode == result.productCode).length == 0) {
            //...
            // } else {
            //     alert(result.productName + (" " + t("syncflow:msg_product_add_error")), t("syncflow:information"));
            // } 
        });
        hideInfoOrders();
    }

    const [selectedRowKeys, setSelectedRowKeys] = useState<any | null>(null);
    const onSelectionChanged = (args: DataGridTypes.SelectionChangedEvent) => {
        setSelectedRowKeys(args.selectedRowsData);
    };

    const handleInitNewRow = async (e: any) => {
        e.data = newProductRow;
    };

    // const renderGridCell = (data: any) => (data.price * data.qty);
    return (
        <>
            <div className='row mb-4 justify-content-end'>


                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_add")}
                        type="default"
                        icon="add"
                        onClick={onAdd}
                    />
                </div>

                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_save")}
                        type="default"
                        icon="save"
                        onClick={onSave}
                    />
                </div>

                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_create_order")}
                        type="success"
                        icon="showpanel"
                        onClick={onCreateOrder}
                    />
                </div>

            </div>

            <div style={{ display: isNew ? 'block' : 'none' }}>
                <div className="row mb-12">
                    <label className="col-lg-1 col-form-label required fw-bold fs-6"> {t("syncflow:location")}</label>
                    <div className="col-lg-3">
                        <div className="row">
                            <div className="fv-row">
                                <SelectBox
                                    name="locationsLookups"
                                    dataSource={locationsLookups}
                                    valueExpr="code"
                                    displayExpr="name"
                                    onValueChanged={onLocationChanged}
                                    showClearButton={true}>
                                    <Validator ref={validatorRef}>
                                        <RequiredRule message="Confirm Store is required" />
                                    </Validator>
                                </SelectBox>
                            </div>
                        </div>
                    </div>
                    <label className="col-lg-1 col-form-label fw-bold fs-6">{t("syncflow:lu_vendor")}</label>
                    <div className="col-lg-3">
                        <div className="row">
                            <div className="fv-row">
                                <SelectBox
                                    name="supplierLookups"
                                    dataSource={supplierLookups}
                                    // value={supplierValue}
                                    valueExpr="code"
                                    displayExpr="name"
                                    searchEnabled={true}
                                    onValueChanged={onSupplierChanged}
                                    showClearButton={true} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="card-body py-3" style={{ display: !isNew ? 'block' : 'none' }}>
                <div className="table-responsive">
                    <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                        <thead>
                            <tr className="fw-bold text-muted">
                                <th className="w-25px">
                                    <div className="form-check form-check-sm form-check-custom form-check-solid"></div>
                                </th>
                                <th className="min-w-150px">{t('syncflow:lb_type')}</th>
                                <th className="min-w-120px">Order Code</th>
                                <th className="min-w-120px">{t('syncflow:lu_store')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_vendor')}</th>

                                <th className="min-w-120px">Order Date</th>
                                <th className="min-w-120px">Delivery Date</th>
                                <th className="min-w-120px">Product Count</th>
                                <th className="min-w-120px">Qty</th>
                                <th className="min-w-120px">Amount</th>
                                <th className="min-w-120px">{t('syncflow:lb_order_supplier_status')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div className="form-check form-check-sm form-check-custom form-check-solid"></div>
                                </td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{t('syncflow:lb_order_type_' + (additionalDetailData?.orderTypeCode))}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{additionalDetailData?.orderCode}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{additionalDetailData?.sourceName}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{additionalDetailData?.targetName}</span></td>

                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(moment(additionalDetailData?.orderDate).format("DD/MM/YYYY"))}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(moment(additionalDetailData?.deliveryDate).format("DD/MM/YYYY"))}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{additionalDetailData?.productCount}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{additionalDetailData?.orderQty}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{"$ " + additionalDetailData?.orderAmount}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{t('syncflow:lb_order_supplier_status_' + additionalDetailData?.supplierStatusCode)}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>



            <React.Fragment>
                <DataGridWrapper
                    props={{ ref: dataGridRef }}
                    datasource={store}
                    remoteOperations={false}
                    showColumnLines={true}
                    columnChooser={true}
                    onSaving={onSaving}
                    onCellPrepared={onCellPrepared}
                    pagerVisible={true}
                    filterVisible={true}
                    headerFilterVisible={true}
                    keyboardNavigation={true}
                    onInitNewRow={handleInitNewRow}
                    editingConfig={{
                        mode: "batch",
                        useIcons: true,
                        allowAdding: false,
                        allowDeleting: true,
                        allowUpdating: true,
                        updateMessageText: RemoveMessage('Resource'),
                    }}


                    columns={[
                        {
                            dataField: 'productCode',
                            caption: t('syncflow:lb_product_code'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'productName',
                            caption: t('syncflow:lb_product_name'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'unitCode',
                            caption: t('syncflow:lb_measurement_unit_code'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'waitingBalance',
                            caption: "Waiting Balance",
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'price',
                            caption: t('syncflow:lb_product_price'),
                            allowFiltering: true,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true },
                        },
                        {
                            dataField: 'orderQty',
                            caption: "Qty",
                            allowFiltering: true,
                            allowEditing: true,
                            dataType: 'number',
                        },
                        // {
                        //     dataField: 'approvedAmount',
                        //     caption: "Total Price",
                        //     allowFiltering: true,
                        //     allowEditing: false,
                        //     calculateCellValue: renderGridCell,
                        //     format: { style: "currency", currency: "USD", useGrouping: true },
                        // },

                    ]}
                />
            </React.Fragment>

            <Popup
                visible={popupVisibleOrders}
                onHiding={hideInfoOrders}
                title="Order products list"
                showTitle={true}
                width={1200}
                height={740}
                position={{ of: window, at: 'center', my: 'center' }}
            >

                <div className='row mb-4 justify-content-end'>
                    <div className='col-auto'>
                        <Button
                            text={t("syncflow:btn_add")}
                            type="default"
                            stylingMode="contained"
                            icon="check"
                            onClick={approveOrders}
                        />
                    </div>
                </div>
                <DataGridWrapper
                    props={{ ref: dgVendorSummaryRef }}
                    datasource={storeVendorSummaries}
                    showColumnLines={true}
                    onSelectionChanged={onSelectionChanged}
                    remoteOperations={false}
                    columnChooser={false}
                    pagerVisible={true}
                    filterVisible={true}
                    headerFilterVisible={true}
                    selectionConfig={{ mode: 'multiple', selectAllMode: 'allPages', showCheckBoxesMode: 'always' }}
                    editingConfig={{
                        mode: "batch",
                        allowDeleting: false,
                        allowUpdating: true,

                    }}
                    columns={[
                        {
                            dataField: 'productCode',
                            caption: 'Product Code',
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'productName',
                            caption: 'Product Name',
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'unit',
                            caption: 'Unit Code',
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        {
                            dataField: 'price',
                            caption: 'Price',
                            allowFiltering: false,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true }
                        },
                        {
                            dataField: 'waitingBalance',
                            caption: 'Waiting Balance',
                            allowFiltering: false,
                            allowEditing: false,
                        },
                        // {
                        //     dataField: 'orderQty',
                        //     caption: 'Order Qty',
                        //     allowFiltering: false,
                        //     allowEditing: false,
                        // }
                    ]}
                />
            </Popup>

        </>


    )
}
export default AdditionalOrder